module.exports = __webpack_public_path__ + "img/1970East-067_WEB-min.b8122c3d.jpg";